// src/lib/imageUrl.js

import imageUrlBuilder from '@sanity/image-url';
import createClient from './sanityClient.js';

const builder = imageUrlBuilder(createClient);

export const urlFor = (source) => builder.image(source);
